/* biome-ignore-all lint/style/noParameterAssign: Need to pass ref for forwardRef */
/* biome-ignore-all lint/style/useComponentExportOnlyModules: Can't wrap certain elements */
/* biome-ignore-all lint/performance/noNamespaceImport: Cleaner when working with libraries */
import * as Dialog from '@radix-ui/react-dialog';
import React from 'react';
import { cn } from '@/app_lib/utils/utils';

const Root = Dialog.Root;
Root.displayName = 'DialogRoot';

const Portal = Dialog.Portal;
Portal.displayName = 'DialogPortal';

const Title = Dialog.Title;
Title.displayName = 'DialogTitle';

const Description = Dialog.Description;
Description.displayName = 'DialogDescription';

const Overlay = Dialog.Overlay;
Overlay.displayName = 'DialogOverlay';

const Trigger = React.forwardRef<
  React.ComponentRef<typeof Dialog.Trigger>,
  React.ComponentPropsWithoutRef<typeof Dialog.Trigger>
>(({ className, children, asChild, ...rest }, ref) => (
  <Dialog.Trigger
    asChild={asChild}
    className={cn(className)}
    ref={ref}
    {...rest}
  >
    {children}
  </Dialog.Trigger>
));
Trigger.displayName = 'DialogTrigger';

const Content = React.forwardRef<
  React.ComponentRef<typeof Dialog.Content>,
  React.ComponentPropsWithoutRef<typeof Dialog.Content>
>(({ className, children, ...rest }, ref) => (
  <Dialog.Content
    className={cn('', className)}
    ref={ref}
    {...rest}
  >
    {children}
  </Dialog.Content>
));
Content.displayName = 'DialogContent';

const Close = React.forwardRef<
  React.ComponentRef<typeof Dialog.Close>,
  React.ComponentPropsWithoutRef<typeof Dialog.Close>
>(({ className, children, ...rest }, ref) => (
  <Dialog.Close
    className={cn('', className)}
    ref={ref}
    {...rest}
  >
    {children}
  </Dialog.Close>
));
Close.displayName = 'DialogClose';

export { Root, Trigger, Close, Content, Portal, Title, Description, Overlay };
